<template>
  <app-modal
    v-model="isDialogOpened"
    size="xs"
    :cancel-text="$t('common.close')"
    cancelOnly
    @cancel="closeDialog"
  >
    <template #title>
      {{ $t('project.documents.dialogs.DocumentsNotRedactableDialog.title') }}
    </template>

    <template #body>
      <p v-for="reason in reasons" :key="reason">
        {{ $t(`project.documents.dialogs.DocumentsNotRedactableDialog.reasons.${reason}`) }}
      </p>
    </template>
  </app-modal>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'

import { dialogMixin } from '@/mixins/dialogMixin'

export default defineComponent({
  name: 'DocumentsNotRedactableDialog',
  mixins: [dialogMixin],
  props: {
    reasons: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
  },
})
</script>
